import { useEffect, useState } from "react";
import { post } from "../../../../services/ApiService";
import toast from "react-hot-toast";

export function useTemplates(initialTemplates) {
  const [templates, setTemplates] = useState(initialTemplates || []);
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    setTemplates(initialTemplates || []);
  }, [initialTemplates]);

  const onDragEnd = async (result) => {
    setIsDragging(false);
    
    if (!result.destination) return;
    
    const items = Array.from(templates);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    
    const updatedItems = items.map((item, index) => ({
      ...item,
      position: index
    }));
    
    setTemplates(updatedItems);
    
    try {
      await post("api/external-log/faqs/update-positions", {
        updates: updatedItems.map(item => ({
          id: item._id,
          position: item.position
        }))
      });
    } catch (error) {
      toast.error("Failed to save new positions");
      console.error(error);
    }
  };

  const onDragStart = () => {
    setIsDragging(true);
  };

  return { templates, setTemplates, isDragging, onDragStart, onDragEnd };
}
